import type { SanityProductVariantSection } from '../product-variant.types';
import { namespaceType } from '@workspace/sanity-base/lib/namespace';

type AnyBlock = { _type?: string; [key: string]: unknown };

export const normalizeBlock = (block: AnyBlock | SanityProductVariantSection): SanityProductVariantSection => {
  // If it's already a SanityProductVariantSection, return as is
  if (
    '_type' in block &&
    (block._type === 'productVariantSection' ||
      block._type === namespaceType('productVariantSection') ||
      (block as unknown as SanityProductVariantSection)._type === 'productVariantSection')
  ) {
    return block as unknown as SanityProductVariantSection;
  }

  // Otherwise, cast to SanityProductVariantSection
  return block as unknown as SanityProductVariantSection;
};
